module.exports = __webpack_public_path__ + "assets/202509252035/img/Joe.ebfc0327.jpg";